import React from 'react';
import { withTranslation } from 'react-i18next';
import Header from '../Header/Header';
import { connect } from 'react-redux';
import { history } from '../helpers/history';
import Footer from '../Footer/Footer';

class PageNotFound extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		const { t } = this.props;
		return (<>
			<Header />
			<div class="subContainer">
				<div class="pasContainer">
					<span class="checkImg"><img src="./assets/img/icons/sad.png" /></span>
					<p>404 {t('lblNotfound')}</p>
					<h3>{t('lblRegret')}</h3>
					<small>{t('lbl404Msg')}</small>
					<a onClick={() => { history.push('/') }}>{t('lblGohome')}</a>
				</div>
			</div>
			<Footer/>
		</>
		);
	}
}

function mapStateToProps(state) {
	return {};
}
const mapActionToProps = {

}


export default connect(mapStateToProps, mapActionToProps)(withTranslation()(PageNotFound))
